import assets from './assets';
import chains from './chains';
import ibc from './ibc';
export default {
    assets, chains, ibc
};
export { assets, chains, ibc };
